import type { SVGProps } from 'react';

export const Keep = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 12.211 17.288 14v1.5H12.75V21l-.75.75-.75-.75v-5.5H6.71V14l1.79-1.789V5h-1V3.5h9V5h-1v7.211ZM8.85 14h6.3L14 12.85V5h-4v7.85L8.85 14Z" />
    </svg>
  );
};
